import React from 'react'
import AllRoutes from './pages/AllRoutes'

const App = () => {

  return (
      <AllRoutes/>
  )
}

export default App